export const theme = {
  colors: {
    // Couleurs principales
    primary: "#FF6B42",
    primaryLight: "#FF8C42", 
    primaryDark: "#FF4500",
    
    // Couleurs secondaires
    secondary: "#5C6BC0",
    secondaryLight: "#8E99F3",
    secondaryDark: "#26418F",
    
    // Couleurs de base
    white: "#FFFFFF",
    black: "#141414",
    
    // Couleurs d'arrière-plan
    background: {
      primary: "#f9f9f9",
      dark: "#1a1a2e",
      darker: "#0f0f1e", 
      blueDark: "#1a1a4e",
      blueNavy: "#090920",
      blueMedium: "#1A1A3A",
      light: "#F4F5F7",
      lighter: "#F8F8F8",
      white: "#FFFFFF",
      gradient: {
        hero: "linear-gradient(135deg, #1a1a2e 0%, #0f0f1e 50%, #1a1a2e 100%)",
        
      }
    },
    
    // Couleurs de texte
    text: {
      primary: "#FFFFFF",
      secondary: "rgba(255, 255, 255, 0.7)",
      dark: "#373e6d",
      medium: "#616161",
      light: "rgba(255, 255, 255, 0.85)",
      default: "#fffcfcff"
    },
    
    // Couleurs d'accent
    accent: {
      orange: "#FF9966",
      pink: "#FF6B9D",
      purple: "#9F7AEA",
      blue: "#4A5568",
      yellow: "#FFD700",
      green: "#25D366",
      spotify: "#1DB954"
    },
    
    // Couleurs des icônes
    icons: {
      rocket: "#FF4D1A",
      triangle: "#FF6B35", 
      spotify: "#1ED760",
      whatsapp: "#25D366"
    },
    
    // Couleurs des dégradés
    gradients: {
      bubble1: "linear-gradient(135deg, #FF6B9D 0%, #C239B3 100%)",
      bubble2: "linear-gradient(135deg, #FF8C42 0%, #FF6B35 100%)",
      bubble3: "linear-gradient(135deg, #FF6B42 0%, #FF4500 100%)",
      bubble4: "linear-gradient(135deg, #4A5568 0%, #2D3748 100%)",
      bubble5: "linear-gradient(135deg, #9F7AEA 0%, #805AD5 100%)",
      button: "linear-gradient(135deg, #ff8a00, #ff4d1a)",
      author: "linear-gradient(135deg, #ff8a00, #ff4d1a)"
    },
    
    // Couleurs des bordures et séparateurs
    border: {
      light: "rgba(255, 255, 255, 0.2)",
      medium: "rgba(255, 255, 255, 0.3)",
      dark: "#E0E0E0",
      white: "rgba(255, 255, 255, 0.1)"
    },
    
    // Couleurs des overlays
    overlay: {
      dark: "rgba(0, 0, 0, 0.8)",
      medium: "rgba(0, 0, 0, 0.6)",
      light: "rgba(0, 0, 0, 0.2)",
      card: "rgba(30, 35, 70, 0.95)",
      container: "rgba(20, 25, 60, 0.6)"
    },
    
    // Couleurs des ombres
    shadow: {
      pink: "rgba(255, 107, 157, 0.4)",
      orange: "rgba(255, 107, 53, 0.5)",
      red: "rgba(255, 69, 0, 0.4)",
      gray: "rgba(45, 55, 72, 0.5)",
      purple: "rgba(159, 122, 234, 0.5)",
      green: "rgba(37, 211, 102, 0.4)",
      card: "rgba(0, 0, 0, 0.3)"
    },
    
    // Couleurs des états
    states: {
      hover: "rgba(255, 255, 255, 0.1)",
      active: "rgba(255, 255, 255, 0.25)",
      transparent: "transparent"
    },
    
    // Couleurs spécifiques aux composants
    components: {
      // Cartes de réalisations
      realization: {
        serena: "#FF8C42",
        metaverse: "#5C6BC0",
        appDev: "#000080",
        totche: "#5C6BC0"
      },
      
      // Équipe
      team: {
        member1: "#090920",
        member2: "#FFD700", 
        member3: "#FF6B42"
      },
      
      // Services
      services: {
        background: "#E8EAF6",
        iconBackground: "#F4F5F7"
      },
      
      // Valeurs
      values: {
        iconSpotify: "rgba(30, 215, 96, 0.2)",
        iconFunnel: "rgba(255, 107, 53, 0.2)"
      }
    }
  },
  
  // Tailles et espacements
  spacing: {
    xs: "4px",
    sm: "8px",
    md: "16px",
    lg: "24px",
    xl: "32px",
    xxl: "48px"
  },
  
  // Breakpoints
  breakpoints: {
    mobile: "768px",
    tablet: "1024px",
    desktop: "1200px"
  },
  
  // Typographie
  typography: {
    fontFamily: {
      primary: "'Poppins', sans-serif"
    },
    fontSize: {
      small: "14px",
      normal: "16px",
      large: "18px",
      xlarge: "24px",
      xxlarge: "32px"
    }
  }
};

export default theme;